export enum SurveySource {
  DRONE = 'drone',
  SATELLITE = 'satellite'
}
